import { render, staticRenderFns } from "./BahasaComponen.vue?vue&type=template&id=43ec591e&scoped=true"
import script from "./BahasaComponen.vue?vue&type=script&lang=js"
export * from "./BahasaComponen.vue?vue&type=script&lang=js"
import style0 from "./BahasaComponen.vue?vue&type=style&index=0&id=43ec591e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ec591e",
  null
  
)

export default component.exports